import React from 'react';

import TextFormField from 'CommonComponents/TextFormField';

export default function TendererField({ name, errors, touched, actions, disabled }) {
    return (
        <div className="tw-grid tw-grid-cols-12 tw-gap-4">
            <div className="tw-grid tw-grid-cols-12 tw-gap-4 tw-col-span-12 md:tw-col-span-11">
                <div className="tw-col-span-12 md:tw-col-span-3">
                    <TextFormField label={$t('Company Name')} required={true} type="text" name={`${name}.company_name`} disabled={disabled}></TextFormField>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3">
                    <TextFormField label={$t('Website')} type="text" name={`${name}.website`} disabled={disabled}></TextFormField>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3">
                    <TextFormField label={$t('Contact Name')} type="text" name={`${name}.contact_name`} disabled={disabled}></TextFormField>
                </div>
                <div className="tw-col-span-12 md:tw-col-span-3">
                    <TextFormField label={$t('Contact Email')} type="text" name={`${name}.contact_email`} disabled={disabled}></TextFormField>
                </div>
            </div>
            {!!actions && <div className="tw-col-span-12 md:tw-col-span-1 tw-flex tw-flex-col tw-mt-6 tw-items-center">{actions}</div>}
        </div>
    );
}
